<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('retailerManagement.delivery_order') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:body>
            <b-row>
                <b-col xl="12" lg="12" sm="12">
                    <ValidationProvider>
                        <b-form-group
                            class="row"
                            label-cols-sm="3"
                            label-for="delivery_type"
                            slot-scope="{ valid, errors }"
                            >
                            <b-form-radio-group
                                v-model="search.delivery_type"
                                :options="orderTypeList"
                                value-field="item"
                                text-field="name"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-radio-group>
                            <div class="invalid-feedback d-block">
                            {{ errors[0] }}
                            </div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <component :is='comp' />
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>

import directDeliveryList from './direct-delivery/directDeliveryList'
import directList from './direct/directList'
import onlineList from './online/onlineList'
import quotationList from './quotation/quotationList'
import salesCenterList from '../../../sales-distribution-admin/pages/delivery-orders/List.vue'
import { mapGetters } from 'vuex'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    onlineList, quotationList, directList, directDeliveryList, salesCenterList
  },
  data () {
    return {
        comp: 'directList',
      saveBtnName: this.$t('globalTrans.save'),
      search: {
        delivery_type: 3
      },
      delivery_type: 0,
      optionsTypeList: [
          { item: 3, text_en: 'Direct Order', text_bn: 'সরাসরি অর্ডার' },
          { item: 4, text_en: 'Direct Delivery', text_bn: 'সরাসরি ডেলিভারি' },
          { item: 1, text_en: 'Online Order', text_bn: 'অনলাইন অর্ডার' },
          { item: 2, text_en: 'Quotation Order', text_bn: 'কোটেশন অর্ডার' },
          { item: 5, text_en: 'Sales Center', text_bn: 'বিক্রয় কেন্দ্র' }
      ]
    }
  },
  computed: {
    orderTypeList: function () {
        return this.optionsTypeList.map(item => {
            return Object.assign({}, item, { name: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
        })
    },
    currentLocale () {
      return this.$i18n.locale
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'search.delivery_type': function (newVal, oldVal) {
        if (newVal !== oldVal) {
            if (parseInt(newVal) === 1) {
                this.comp = 'onlineList'
            } else if (parseInt(newVal) === 2) {
                this.comp = 'quotationList'
            } else if (parseInt(newVal) === 3) {
                this.comp = 'directList'
            } else if (parseInt(newVal) === 5) {
              this.comp = 'salesCenterList'
            } else {
                this.comp = 'directDeliveryList'
            }
        }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>
